import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Store, StoreCode, Details, Name, Interactions } from './TopStores.style'
import { Helpers, NoResults } from '../common'
import { Arrow } from '../../../..'
import { NumberUtils } from '../../../../../utils'

const TopStores = ({ isEmpty, stores }) => (
    <Fragment>
        {isEmpty && <NoResults />}
        {!isEmpty &&
            stores.map(({ store, store_code, interactions, delta }, index) => {
                const displayInteractions = NumberUtils.withDecimalsIfNeeded(interactions)

                return (
                    <Store key={store_code}>
                        <Details>
                            <Name>
                                {index + 1}
                                &#46;&nbsp;&nbsp;&nbsp;
                                <StoreCode>{store_code}</StoreCode>
                                &nbsp;
                                {store && store.name}
                            </Name>
                            <Arrow direction={Helpers.transformDeltaToKey(delta)} colored />
                        </Details>
                        <Interactions>{`${displayInteractions} interactions`}</Interactions>
                    </Store>
                )
            })}
    </Fragment>
)

TopStores.propTypes = {
    isEmpty: PropTypes.bool,
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
}

TopStores.defaultProps = {
    isEmpty: true,
    stores: [],
}

export default TopStores
